import { createReducer, on } from '@ngrx/store';
import {
  DELIVERY_ZONE_CUSTOMER_FIND_SUCCESS,
  DELIVERY_ZONE_CUSTOMER_FAILURE,
  DELIVERY_ZONE_CUSTOMER_UPDATE_FORM,
  DELIVERY_ZONE_CUSTOMER_RESET_ERROR,
  DELIVERY_ZONE_CUSTOMER_RESET,
  DELIVERY_ZONE_CUSTOMER_RESET_FORM,
  DELIVERY_ZONE_CUSTOMER_FIND_ALL_SUCCESS,
  DELIVERY_ZONE_CUSTOMER_EDIT_MODE,
  DELIVERY_ZONE_CUSTOMER_UPDATE_ID,
  DELIVERY_ZONE_CUSTOMER_UPDATE_LOADING

  
} from '../actions';
import { IResponseBadRequest } from '@core/interfaces';
import { DeliveryZoneCustomer, DeliveryZoneCustomerForm } from '@core/models';

export interface DeliveryZoneCustomerState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  deliveryZoneCustomer: DeliveryZoneCustomer | null;
  deliveryZoneCustomerList: DeliveryZoneCustomer[] | null;
  deliveryZoneCustomerForm: DeliveryZoneCustomerForm | null;
  deliveryZoneCustomerId: string | null;
  error: IResponseBadRequest | null;
}

export const initialState: DeliveryZoneCustomerState = {
  loading: false,
  editMode: false,
  isEditing: false,
  deliveryZoneCustomer: null,
  deliveryZoneCustomerList: null,
  deliveryZoneCustomerForm: null,
  deliveryZoneCustomerId: null,
  error: null,
};
export const deliveryZoneCustomerReducer = createReducer(
  initialState,
  on(DELIVERY_ZONE_CUSTOMER_EDIT_MODE, (state, { editMode }) => ({ ...state, editMode })),
  on(DELIVERY_ZONE_CUSTOMER_FIND_SUCCESS, (state, { deliveryZoneCustomer }) => ({ ...state, deliveryZoneCustomer})),
  on(DELIVERY_ZONE_CUSTOMER_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(DELIVERY_ZONE_CUSTOMER_FIND_ALL_SUCCESS, (state, { deliveryZoneCustomerList }) => ({ ...state, deliveryZoneCustomerList })),
  on(DELIVERY_ZONE_CUSTOMER_FAILURE, (state, { error }) => ({ ...state, error })),
  on(DELIVERY_ZONE_CUSTOMER_UPDATE_FORM, (state, { deliveryZoneCustomerForm }) => ({ ...state, deliveryZoneCustomerForm: deliveryZoneCustomerForm })),
  on(DELIVERY_ZONE_CUSTOMER_RESET, (state) => ({ ...state, deliveryZoneCustomer: initialState.deliveryZoneCustomer })),
  on(DELIVERY_ZONE_CUSTOMER_RESET_ERROR, (state) => ({ ...state, error: initialState.error })),
  on(DELIVERY_ZONE_CUSTOMER_RESET_FORM, (state) => ({ ...state, deliveryZoneCustomerForm: initialState.deliveryZoneCustomerForm, loading: initialState.loading })),
  on(DELIVERY_ZONE_CUSTOMER_UPDATE_ID, (state, { deliveryZoneCustomerId }) => ({ ...state, deliveryZoneCustomerId })),
);
